import { useItem } from '@/composables/item'
import { notificationService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'
import { useAlertStore } from '../system'

export const useNotificationStore = defineStore('notification', () => {
	const countUnread = ref()
	const countRead = ref()
	const data = ref([])
	const meta = ref({})
	const status = ref('initial')

	const { items, show, getItem } = useItem(
		notificationService,
		'notifications',
		'Notification',
		{
			options: {
				parseIdAsInt: false,
			},
		}
	)

	function countSet({ unread = true, count }) {
		if (unread) {
			countUnread.value = count
		} else {
			countRead.value = count
		}
	}
	function dataSet(value) {
		data.value = value
	}
	function linksSet(value) {
		links.value = value
	}
	function metaSet(value) {
		meta.value = meta
	}
	function statusSet(value) {
		status.value = value
	}

	function count(unread = true) {
		return notificationService.indexCount(unread).then(
			({ data: result }) => {
				countSet({ unread, count: result.count })
				return result.count
			},
			(error) => {
				/*dispatch('error', error, { root: true })*/
				return error
			}
		)
	}
	function mark({ id, read = true }: { id: string; read?: boolean }) {
		return notificationService.mark(id, read).then(
			(data) => {
				return data
			},
			(error) => {
				useAlertStore().errorAlert(error)
				return error
			}
		)
	}
	function markAllRead() {
		return notificationService.markAllRead().then(
			(data) => {
				return data
			},
			(error) => {
				useAlertStore().errorAlert(error)
				return error
			}
		)
	}

	return {
		status,
		countUnread,
		countRead,
		data,
		meta,
		countSet,
		dataSet,
		linksSet,
		metaSet,
		statusSet,

		count,
		mark,
		markAllRead,

		items,
		show,
		getItem,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useNotificationStore, import.meta.hot))
}
